const config = {
    BASE_URL:  "https://enterprise.concise5.com/oe"  //"http://34.27.108.171/oe"    "https://enterprise.concise5.com/oe" 
}
export default config;